import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "18",
  viewBox: "0 0 20 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.5566 6.5C19.4498 8.04701 19.4498 9.95299 18.5566 11.5L16.4434 15.1603C15.5502 16.7073 13.8996 17.6603 12.1132 17.6603L7.88675 17.6603C6.10043 17.6603 4.44979 16.7073 3.55663 15.1603L1.44338 11.5C0.550214 9.95299 0.550214 8.047 1.44338 6.5L3.55663 2.83975C4.44979 1.29274 6.10043 0.339745 7.88675 0.339745L12.1132 0.339745C13.8996 0.339745 15.5502 1.29274 16.4434 2.83975L18.5566 6.5Z",
      fill: "#54BD01"
    }, null, -1)
  ])))
}
export default { render: render }